import { useSupabase } from '@packages/supabase'
import useSWR from 'swr'

export const useTenant = (tenantId: string, data?: any) => {
  const { supabase } = useSupabase()

  const key = tenantId ?? 'tenant_' + tenantId

  const tenant = useSWR(
    key,
    () =>
      supabase
        .from('tenants')
        .select('*')
        .eq('id', tenantId)
        .single()
        .then((r) => {
          if (!r.data.id) {
            throw 'could not load tenant record '
          }
          return r.data
        }),
    {
      fallbackData: data
    }
  )

  const update = (updateData: Partial<Tenant>) =>
    supabase
      .rpc('admin_update_tenant', {
        p_tenant_id: tenantId,
        p_updates: updateData
      })
      .select()
      .single()
      .then(({ error, data }) => {
        if (error) {
          console.error('Error updating tenants:', error)
          return null
        }

        const updatedTenant = Array.isArray(data) ? data[0] : data || null

        if (!updatedTenant) {
          console.error(
            'Update succeeded but no data returned. Tenant may not exist.'
          )
          return null
        }

        tenant.mutate(updatedTenant, false)
        return updatedTenant
      })

  const users = () =>
    useSWR(key + '_users', () =>
      supabase.from('users').select('*').eq('tenant_id', tenantId)
    )

  return {
    ...tenant,
    update,
    users
  }
}
